export default {
      id: "command__update_key-usage",
      viewBox: "0 0 92.7 88.2",
      url: __webpack_public_path__ + "img/icons.svg#command__update_key",
      toString: function () {
        return this.url;
      }
    }